import { Col, Menu, Row, Dropdown, Tag } from 'antd'
import { BaseButton } from 'components/elements/BaseButton'
import { globalConfirm, globalToaster } from 'components/elements/global'
import { AddTaskModal } from 'components/shared/Modals'
import {
 leadApi,
 useDeleteLeadEventMutation,
 useTaskCompletedMutation,
} from 'features/leads/api'
import { TAddLeadEventBody, TTaskType } from 'features/leads/types'
import { useAppDispatch } from 'hooks'
import { FC, useState } from 'react'
import { TModalState } from 'types'
import { useNavigate } from 'react-router'
import { baseTime } from 'lib'
import ProInnerCard from '../../ProInnerCard'
import SimpleBlockItem from '../../SimpleBlockItem'
import RecurringTaskModal from './RecuringTaskModal'

type RECCURING_TASK_TYPE = {
 show: boolean
 id?: any
 name?: string
}

type Props = {
 tasks?: TTaskType[]
 leadId?: any
 isTransferred?: boolean
}

const TasksBlock: FC<Props> = ({ tasks, leadId, isTransferred }) => {
 const [showRrModal, setRrModal] = useState<RECCURING_TASK_TYPE>()
 const navigate = useNavigate()
 const dispatch: any = useAppDispatch()
 const [taskCompleted] = useTaskCompletedMutation()
 const [deleteLeadEvent] = useDeleteLeadEventMutation()

 const [showTaskModal, setShowTaskModal] = useState<
  { editableType?: 'multiple' | 'single' } & TModalState<TAddLeadEventBody>
 >({ show: false, mode: 'ADD' })

 const refreshLead = () => dispatch(leadApi.util.invalidateTags(['LEAD']))

 const confirmAndCompleteTask = (
  id: string[],
  recurringEventId?: number,
  type?: 'multiple' | 'single' | 'all',
 ) => {
  globalConfirm({
   content: 'Are you sure want to complete this task?',
   onOk: async () => {
    await taskCompleted({
     id,
     recurring_events_id: recurringEventId as any,
     ...(type ? { complete: type } : {}),
    }).unwrap()
   },
  })
  refreshLead()
 }

 const confirmAndDeleteTask = (
  id?: any,
  recurringEventId?: number,
  deleteType?: 'multiple' | 'single' | 'all',
 ) => {
  globalConfirm({
   content: 'Are you sure you want to delete the task?',
   onOk: async () => {
    await deleteLeadEvent({
     id,
     feed: 'task',
     ...(deleteType && {
      deletable: deleteType,
      recurring_events_id: recurringEventId,
     }),
    }).unwrap()
    refreshLead()
   },
  })
 }

 const renderEditButton = (item: TTaskType) => {
  // if (item.is_recurring) {
  //  return (
  //   <Dropdown
  //    overlay={
  //     <Menu
  //      items={[
  //       {
  //        key: 'edit-single',
  //        label: 'Only this occurrence',
  //        onClick: () =>
  //         setShowTaskModal({
  //          show: true,
  //          data: { ...item, feed: 'task', title: item.name },
  //          mode: 'EDIT',
  //          editableType: 'single',
  //         }),
  //       },
  //       {
  //        key: 'edit-multiple',
  //        label: 'All future occurrence',
  //        onClick: () =>
  //         setShowTaskModal({
  //          show: true,
  //          data: { ...item, feed: 'task', title: item.name },
  //          mode: 'EDIT',
  //          editableType: 'multiple',
  //         }),
  //       },
  //      ]}
  //     />
  //    }
  //   >
  //    <BaseButton
  //     className="ant-btn-outline-primary"
  //     size="small"
  //     buttonType="primary"
  //     icon={<i className="fas fa-edit" />}
  //    />
  //   </Dropdown>
  //  )
  // }

  return (
   <BaseButton
    size="small"
    className="ant-btn-outline-primary"
    buttonType="primary"
    icon={<i className="fas fa-edit" />}
    onClick={() =>
     setShowTaskModal({
      show: true,
      data: { ...item, feed: 'task', title: item.name },
      mode: 'EDIT',
     })
    }
   />
  )
 }

 const renderCompleteButton = (item: TTaskType) => {
  if (item.task_status === 'overdue') {
   return (
    <BaseButton
     title="Mark as Completed"
     className="ant-btn-outline-primary"
     size="small"
     icon={<i className="fas fa-check" />}
     style={{ cursor: 'pointer' }}
     onClick={() => confirmAndCompleteTask([item.id])}
    />
   )
  }

  // if (item.is_recurring) {
  //  return (
  //   <Dropdown
  //    overlay={
  //     <Menu
  //      items={[
  //       {
  //        key: 'complete-single',
  //        label: 'Complete current task',
  //        onClick: () =>
  //         confirmAndCompleteTask([item.id], item.recurring_events_id),
  //       },
  //       {
  //        key: 'complete-multiple',
  //        label: 'Complete all future occurrence',
  //        onClick: () =>
  //         confirmAndCompleteTask(
  //          [item.id],
  //          item.recurring_events_id,
  //          'multiple',
  //         ),
  //       },
  //      ]}
  //     />
  //    }
  //   >
  //    <BaseButton
  //     className="ant-btn-outline-primary"
  //     size="small"
  //     icon={<i className="fas fa-check" />}
  //     style={{ cursor: 'pointer' }}
  //    />
  //   </Dropdown>
  //  )
  // }
 }

 const renderDeleteButton = (item: TTaskType) => {
  if (item.is_recurring) {
   return (
    <Dropdown
     overlay={
      <Menu
       items={[
        {
         key: 'delete-single',
         label: 'Only this occurrence',
         onClick: () =>
          confirmAndDeleteTask(item.id, item.recurring_events_id, 'single'),
        },
        {
         key: 'delete-multiple',
         label: 'All future occurrence',
         onClick: () =>
          confirmAndDeleteTask(item.id, item.recurring_events_id, 'multiple'),
        },
        {
         key: 'delete-all',
         label: 'Delete all task',
         onClick: () =>
          confirmAndDeleteTask(item.id, item.recurring_events_id, 'all'),
        },
       ]}
      />
     }
    >
     <BaseButton
      className="ant-btn-outline-primary"
      size="small"
      buttonType="primary"
      icon={<i className="fas fa-trash" />}
     />
    </Dropdown>
   )
  }

  return (
   <BaseButton
    className="ant-btn-outline-primary"
    size="small"
    buttonType="primary"
    icon={<i className="fas fa-trash" />}
    onClick={() => confirmAndDeleteTask(item.id)}
   />
  )
 }

 return (
  <div>
   <ProInnerCard
    title="Tasks"
    emptyText="Tasks is Empty"
    isEmpty={!tasks?.length}
    onCLickAdd={
     isTransferred
      ? () => setShowTaskModal({ show: true, mode: 'ADD' })
      : undefined
    }
   >
    <Row gutter={[15, 15]}>
     {tasks?.map((item, i) => (
      <Col key={i} span={24}>
       <SimpleBlockItem
        actions={
         // eslint-disable-next-line no-nested-ternary
         isTransferred
          ? isTransferred && item?.is_recurring === 1
            ? [
               <BaseButton
                key="view--task"
                title="view--task"
                onClick={() => {
                 setRrModal({
                  show: true,
                  id: item.recurring_events_id,
                  name: item.name,
                 })
                }}
                className="ant-btn-outline-primary"
                size="small"
                buttonType="primary"
                icon={<i className="fas fa-eye" />}
               />,
              ]
            : [
               //  <BaseButton
               //   key="calendar"
               //   title="Calendar"
               //   className="ant-btn-outline-primary"
               //   size="small"
               //   buttonType="primary"
               //   onClick={() =>
               //    navigate(
               //     `/admin/calendar?date=${item.date}&type=task&showModal=true`,
               //     { state: item },
               //    )
               //   }
               //   icon={<i className="fas fa-calendar" />}
               //  />,
               renderEditButton(item),
               ...(item?.task_status === 'overdue'
                ? [renderCompleteButton(item)]
                : []),
               renderDeleteButton(item),
              ]
          : undefined
        }
        contentNode={
         <div style={{ display: 'flex', flexDirection: 'column', rowGap: 4 }}>
          <h4 style={{ marginBottom: 0, lineHeight: 1 }}>{item?.name}</h4>
          {item?.is_recurring === 0 && (
           <>
            <div className="text-muted" style={{ fontSize: 12 }}>
             {item?.date && item.time
              ? baseTime(
                 `${item.date} ${item.time}`,
                 'YYYY-MM-DD hh:mm:ss',
                ).format('DD MMM YYYY hh:mm A')
              : ''}
            </div>
            <div style={{ display: 'flex' }}>
             <Tag
              className="text-capitalize"
              color={
               item?.task_status === 'completed'
                ? 'green'
                : item?.task_status === 'overdue'
                ? 'red'
                : 'orange'
              }
             >
              {item?.task_status}
             </Tag>
            </div>
           </>
          )}
          {item?.is_recurring === 1 && (
           <div className="text-success" style={{ fontSize: 13 }}>
            RECURRING TASK
           </div>
          )}
         </div>
        }
       />
      </Col>
     ))}
    </Row>
   </ProInnerCard>

   {showRrModal?.show && (
    <RecurringTaskModal
     leadId={leadId}
     taskName={showRrModal.name}
     visible={showRrModal.show}
     onSuccess={() => {
      refreshLead()
     }}
     recurringEventId={showRrModal.id}
     onCancel={() =>
      setRrModal({ show: false, id: undefined, name: undefined })
     }
    />
   )}

   {showTaskModal.show && (
    <AddTaskModal
     visible={showTaskModal.show}
     editData={showTaskModal.data}
     mode={showTaskModal.mode}
     leadId={leadId}
     editableType={showTaskModal?.editableType}
     autoFocusTitle
     onCancel={() => setShowTaskModal({ show: false, mode: 'ADD' })}
    />
   )}
  </div>
 )
}

export default TasksBlock
